module.exports = __webpack_public_path__ + "img/navigation.47d6d4bb.svg";